module.exports = __webpack_public_path__ + "img/wangjimima2.7f10569b.png";